
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"35","height":"35","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.462 14.219h-.038a.81.81 0 01-.782-.853l.219-5.092a.811.811 0 01.842-.787.82.82 0 01.782.853l-.219 5.097a.82.82 0 01-.803.782z","fill":"#fff"}}),_c('path',{attrs:{"d":"M30.488 9.762h-.11l-4.806-.635a.827.827 0 11.213-1.64l4.807.64a.822.822 0 11-.104 1.64v-.005z","fill":"#fff"}}),_c('path',{attrs:{"d":"M17.5 30.625a13.125 13.125 0 110-26.25.82.82 0 010 1.64 11.484 11.484 0 107.656 2.905.82.82 0 01.818-1.388.82.82 0 01.276.163 13.125 13.125 0 01-8.75 22.93z","fill":"#fff"}})])
          )
        }
      }
    